import MobileFrame from '../../assets/mobile_preview.svg';
import TabletFrame from '../../assets/tablet_preview.svg';
import React from 'react';

export function DeviceContainer({ deviceType }) {
  if (!deviceType) {
    return null;
  }

  return (
    <>
      {deviceType === 'mobile' && <img src={MobileFrame} alt='mobile frame' />}
      {deviceType === 'tablet' && <img src={TabletFrame} alt='tablet frame' />}
    </>
  )
}